import React, { useContext, createContext, useState, useEffect } from 'react';
import { getPatient } from 'services/patients';
import { showError } from 'utils/alerts';

export const PatientContext = createContext({});

export const PatientProvider = ({
	patientId,
	children,
}: {
	children: React.ReactNode;
	patientId?: string;
}) => {
	const [patient, setPatient] = useState<PatientType>({});
	const [fetching, setFetching] = useState<boolean>(true);

	useEffect(() => {
		fetch();
	}, []);

	const fetch = async (id?: number | string) => {
		try {
			let _patientId = patientId || id;
			if (_patientId) {
				setFetching(true);
				const { data } = await getPatient(_patientId);
				setPatient({ ...patient, ...data });
			}
		} catch (error) {
			showError('There was a problem trying to get patient data.');
		} finally {
			setFetching(false);
		}
	};

	return (
		<PatientContext.Provider
			value={{ patient, setPatient, fetching, fetchPatient: fetch }}
		>
			{children}
		</PatientContext.Provider>
	);
};
